import React, { useContext, useEffect, useState } from "react";
import Utils from "../../../../Common/Utils";
import Label from "../../../Common/components/Label";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import AppSettings from "../../../../Settings/AppSettings";
import { AppContext } from "../../../../Context/AppContext";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import _ from "lodash";
import "./Category.css";
import ViewMoreButton from "../../../Common/components/ViewMoreButton";
// number of attributes to show at a time
const _max_items_show = 5;
const Category = ({
  setAssociatedCategory,
  existingCategory = [],
  attributeId,
  setSelectedCategory,
  setPrevSelectedCategory,
  saveMessage = null,
}) => {
  let appContext = useContext(AppContext);
  let [searchString, setSearchString] = useState("");
  const [sortedAttributeList, setSortedAttributeList] = useState([]);
  let [associatedAttributes, setAssociatedAttributes] =
    useState(existingCategory);

  let [filteredAttList, setFilteredAttList] = useState(sortedAttributeList);
  const [checkedAttributes, setCheckedAttributes] = useState(existingCategory);
  const [viewMoreCategories, setViewMoreCategories] = useState(false);
  const [viewSelCategories, setViewSelCategories] = useState(false);

  let industryId =
    appContext.get_selected_industry() && appContext.get_selected_industry().id;
  const [collapse1, setCollapse1] = useState(false);
  const [attributeList, setAttributeList] = useState(null);
  const [loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const [categoryTypes, setCategoryTypes] = useState([
    { name: "All Category Types", id: "none" },
  ]);
  const [optionsStateValue, setOptionsStateValue] = useState("none");
  const [categoryTypesAtt, setCategoryTypesAtt] = useState([]);
  const [showClearAllFlag, setshowClearAllFlag] = useState(true);

  useEffect(() => {
    setCheckedAttributes(existingCategory);
    const sharedFlag = checkSharedCategories(existingCategory);
    setshowClearAllFlag(sharedFlag);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [existingCategory.length > 0]);
  // useEffect(() => {
  //   setAssociatedAttributes(null);
  //   setAttributeList(null);
  //   setLoading({
  //     status: "",
  //     message: "",
  //   });
  // }, [attributeId]);

  useEffect(() => {
    load_Attributes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [industryId]);

  function updateCategories(filteredCatAttList, checkedCatArray) {
    for (const catObject of checkedCatArray) {
      filteredCatAttList = filteredCatAttList.filter((item) => {
        return item.id !== catObject.id;
      });
    }
    return filteredCatAttList;
  }

  useEffect(() => {
    if (searchString === "") {
      // const catFinalData = updateCategories(filteredAttList, existingCategory);
      let catFinalData = updateCategories(filteredAttList, checkedAttributes);
      catFinalData = sortCatArray(catFinalData);
      setFilteredAttList(catFinalData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchString]);

  useEffect(() => {
    setCheckedAttributes([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributeId === null]);

  useEffect(() => {
    setSelectedCategory(checkedAttributes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedAttributes]);

  async function handleSearchAttribute(value) {
    setSearchString(value);
    if (!Utils.isEmpty(value)) {
      let searchval = value.toString().trim().toLowerCase();
      let filteredData = sortedAttributeList.filter((item) => {
        return (
          (item.name != null && item.name.toLowerCase().includes(searchval)) ||
          (item.description != null &&
            item.description.toLowerCase().includes(searchval))
        );
      });
      let catFinalData = updateCategories(filteredData, checkedAttributes);
      catFinalData = mapDeletedItem(catFinalData);
      catFinalData = sortCatArray(catFinalData);
      setFilteredAttList(catFinalData);
    } else {
      let catFinalData = updateCategories(
        sortedAttributeList,
        checkedAttributes
      );
      catFinalData = mapDeletedItem(catFinalData);
      catFinalData = sortCatArray(catFinalData);
      setFilteredAttList(catFinalData);
    }

    const categoryTypesAttArr = updateCategories(
      sortedAttributeList,
      checkedAttributes
    );
    setCategoryTypesAtt(categoryTypesAttArr);
  }

  function handle_collapse() {
    setCollapse1(!collapse1);
  }

  async function load_Attributes(showStatus = true) {
    if (showStatus) {
      setLoading({
        status: "Loading",
        message: "Loading Categories",
      });
    }
    // /category/getbyindustryid/<industryid></industryid>
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let ret = await ServiceWrapper.doGet(
      `${api_base_url}category/getbyindustryid/${industryId}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!ret.errorfound) {
      await setAttributeList(ret.data.data);
      let catData = ret.data.data;
      // setFilteredAttList(ret.data.data);
      existingCategory = mapExistingCategories(catData, existingCategory);
      setPrevSelectedCategory(existingCategory);
      setCheckedAttributes(existingCategory);
      setAssociatedCategory(ret.data.data);

      if (catData?.length > 0) {
        const allUnckedCategories = updateCategories(catData, existingCategory);
        const catFinalData = sortCatArray(allUnckedCategories);
        setFilteredAttList(catFinalData);
      }

      // fetch Categories type
      const catTypes = await ServiceWrapper.doGet(
        `${api_base_url}categorytype/getbyindustryid/${industryId}`,
        null,
        null,
        AuthManager.getGmsToken()
      );

      let catTypesArr = [];
      if (!catTypes.errorfound) {
        catTypesArr = catTypes?.data?.data;
        setCategoryTypes([...categoryTypes, ...catTypesArr]);
      }

      setLoading({
        status: "Success",
        message: undefined,
      });
    } else {
      setLoading({
        status: "Error",
        message: "Error while Loading Attributes",
      });
    }
  }

  function mapExistingCategories(allCatItemsArr, existingCatArr) {
    const arr = [];
    existingCatArr.forEach((item) => {
      for (const catItem of allCatItemsArr) {
        if (item.id === catItem.id) {
          catItem.shared = item.shared;
          arr.push(catItem);
          break;
        }
      }
    });
    return arr;
  }

  useEffect(() => {
    if (optionsStateValue === "none" && searchString === "") {
      if (sortedAttributeList.length > 0) {
        const filteredCategoryArrData = updateCategories(
          sortedAttributeList,
          checkedAttributes
        );
        const catFinalData = sortCatArray(filteredCategoryArrData);
        setFilteredAttList(catFinalData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsStateValue]);

  function getChecked(id) {
    let obj = checkedAttributes.find((att) => att.id === id);
    return obj !== undefined;
  }

  useEffect(() => {
    let arr = [];
    if (
      associatedAttributes &&
      associatedAttributes.length > 0 &&
      attributeList
    ) {
      attributeList.map((i) => {
        let obj = associatedAttributes.find((att) => att.id === i.id);
        if (obj !== undefined) {
          arr.unshift(i);
        } else {
          arr.push(i);
        }
        return true;
      });
    } else if (attributeList) {
      arr = [...attributeList];
    }

    setSortedAttributeList(arr);
    if (attributeId === "0") {
      setSortedAttributeList([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributeList, attributeId !== "0"]);

  const fromSelectedToAllCategory = (categoryItem) => {
    categoryItem.removed_from_selected = true;
    let index = checkedAttributes.findIndex(
      (att) => att.id === categoryItem.id
    );
    if (index === -1) {
      setCheckedAttributes([...checkedAttributes, categoryItem]);
    } else {
      let checkedArr = [...checkedAttributes];
      checkedArr.splice(index, 1);
      setCheckedAttributes(checkedArr);
      if (categoryTypesAtt.length >= filteredAttList.length) {
        let existingFlag = 0;
        const updatedCategoryTypesAtt = categoryTypesAtt.map((item) => {
          if (item.id === categoryItem.id) {
            existingFlag = 1;
            item.removed_from_selected = true;
          }
          return item;
        });
        if (existingFlag === 0) {
          setCategoryTypesAtt([...updatedCategoryTypesAtt, categoryItem]);
        } else {
          setCategoryTypesAtt(updatedCategoryTypesAtt);
        }
      }
      const catArrData = sortCatArray([...filteredAttList, categoryItem]);
      setFilteredAttList(catArrData);
      // To reset search and filter when there is no data found in selected categories
      if (searchString !== "") {
        setSearchString("");
        const allUnckedCategories = updateCategories(
          sortedAttributeList,
          checkedArr
        );
        const catArrData = sortCatArray(allUnckedCategories);
        setFilteredAttList(catArrData);
      }
      setOptionsStateValue("none");
      const sharedFlag = checkSharedCategories(checkedArr);
      setshowClearAllFlag(sharedFlag);
    }
  };

  const clearAllCheckedItems = () => {
    let clearCheckedItems = checkedAttributes.map((item) => {
      item.removed_from_selected = true;
      return item;
    });
    const sharedCategories = clearCheckedItems.filter((item) => item.shared);
    clearCheckedItems = clearCheckedItems.filter((item) => !item.shared);
    const actualFilteredArrData = updateCategories(
      sortedAttributeList,
      clearCheckedItems
    );
    const catArrData = sortCatArray([...filteredAttList, ...clearCheckedItems]);
    setFilteredAttList(catArrData);
    setCategoryTypesAtt([...actualFilteredArrData, ...clearCheckedItems]);
    setCheckedAttributes(sharedCategories);

    if (searchString !== "") {
      setSearchString("");
      const catArrData = sortCatArray(sortedAttributeList);
      setFilteredAttList(catArrData);
    }
    setOptionsStateValue("none");
    // const sharedFlag = checkSharedCategories(checkedAttributes)
    setshowClearAllFlag(false);
  };

  const filterCategories = (category_id) => {
    setSearchString("");
    setOptionsStateValue(category_id);
    let actualCategoryData =
      categoryTypesAtt.length > 0 ? categoryTypesAtt : filteredAttList;

    if (category_id !== "none") {
      let filteredCategoriesData = actualCategoryData?.filter((item) => {
        return item.cattype === category_id;
      });
      actualCategoryData = updateCategories(
        actualCategoryData,
        checkedAttributes
      );
      setCategoryTypesAtt(actualCategoryData);
      filteredCategoriesData = mapDeletedItem(filteredCategoriesData);
      const catArrData = sortCatArray(filteredCategoriesData);
      setFilteredAttList(catArrData);
      // [categoryTypesAtt,setCategoryTypesAtt]
    } else {
      actualCategoryData = updateCategories(
        categoryTypesAtt,
        checkedAttributes
      );
      actualCategoryData = mapDeletedItem(actualCategoryData);
      const catArrData = sortCatArray(actualCategoryData);
      setFilteredAttList(catArrData);
      setCategoryTypesAtt([]);
    }
  };

  function mapDeletedItem(categoryArr) {
    for (const cat of existingCategory) {
      categoryArr = categoryArr.map((item) => {
        if (item.id === cat.id) {
          item.removed_from_selected = true;
        }
        return item;
      });
    }
    return categoryArr;
  }
  function sortCatArray(catArr) {
    catArr = _.orderBy(catArr, ["name"], ["asc"]);
    return catArr;
  }

  function checkSharedCategories(allCategoriesArr) {
    let sharedFlag = false;
    allCategoriesArr.map((item) => {
      if (!item.shared) {
        sharedFlag = true;
      }
      return true;
    });
    return sharedFlag;
  }

  return (
    <>
      <div className="accordion" id="accordionFlushCat1">
        <div className="border-0 accordion-item">
          <div
            className="bg-white accordion-button collapsed"
            onClick={() => handle_collapse()}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#flush-collapseCat1"
            aria-controls="flush-collapseCat1"
            style={Utils.borderStyle()}
          >
            <div>
              <Label message="Categories" />
            </div>
          </div>

          <div
            id="flush-collapseCat1"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingCat1"
            data-bs-parent="#accordionFlushCat1"
          >
            <div className="p-0 accordion-body" style={{ minHeight: "30px" }}>
              <div className="p-0 mb-3 rounded shadow card bg-body ">
                <div className="selected-category">
                  <div className="selected-category-heading">
                    Selected Categories
                    <span className="badge badge-light">
                      {checkedAttributes?.length}
                    </span>
                  </div>
                  <div className="selected-category-items align-items-center">
                    <div className="flex-wrap d-flex">
                      {checkedAttributes && checkedAttributes.length > 0 ? (
                        <>
                          {checkedAttributes
                            .slice(
                              0,
                              viewSelCategories
                                ? checkedAttributes.length
                                : Math.min(
                                    _max_items_show,
                                    checkedAttributes.length
                                  )
                            )
                            .map((item, index) => (
                              <div className="selected-1" key={item?.name + index}>
                                <input
                                  type="checkbox"
                                  className="text-white btn-check"
                                  name="options-outlined"
                                  id={`success-outlined${index}`}
                                  autoComplete="off"
                                  checked={getChecked(item.id)}
                                />
                                {!item.shared ? (
                                  <label
                                    className="btn btn-outline-primary btn-sm"
                                    htmlFor={`success-outlined${index}`}
                                  >
                                    {item.name}
                                    &nbsp;&nbsp;
                                    <span
                                      className="new-close-icon"
                                      onClick={() =>
                                        fromSelectedToAllCategory(item)
                                      }
                                    >
                                      <svg
                                        width="19"
                                        height="19"
                                        viewBox="0 0 19 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M14 5L5 14"
                                          stroke="#091CAA"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M5 5L14 14"
                                          stroke="#091CAA"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </span>
                                  </label>
                                ) : (
                                  <OverlayTrigger
                                    placement="bottom"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                      <Popover id="popover-basic">
                                        <Popover.Body>
                                          Attribute associated with categories,
                                          products, rules or builder cannot be
                                          removed.
                                        </Popover.Body>
                                      </Popover>
                                    }
                                  >
                                    <label
                                      className="unselected-category"
                                      htmlFor={`success-outlined${item.id}`}
                                    >
                                      {item.name}
                                      &nbsp;&nbsp;
                                    </label>
                                  </OverlayTrigger>
                                )}
                              </div>
                            ))}
                        </>
                      ) : (
                        <>
                          <div className="no-cat-found">
                            No Categories found
                          </div>
                        </>
                      )}
                      <ViewMoreButton
                        state={viewSelCategories}
                        handleClick={() =>
                          setViewSelCategories(!viewSelCategories)
                        }
                        condition={checkedAttributes?.length > _max_items_show}
                      />
                    </div>
                    {checkedAttributes?.length > 0 && showClearAllFlag ? (
                      <span
                        className="selected-category-clear"
                        onClick={clearAllCheckedItems}
                      >
                        Clear All
                      </span>
                    ) : null}
                  </div>
                </div>

                <div className="select-category-section">
                  <div className="select-category-top">
                    <div className="selected-category-heading">
                      Select Categories
                    </div>

                    <div className="select-category-top-right d-flex">
                      <div className="select-category-dropdown select-category-search">
                        <select
                          className="form-select"
                          onChange={(e) => filterCategories(e.target.value)}
                          value={optionsStateValue}
                        >
                          {categoryTypes.map((item) => {
                            return (
                              <option key={item?.id} value={item.id} label={item.name}>
                                {item.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="select-category-search">
                        <input
                          type="text"
                          className="mb-3 border form-control form-control-sm border-secondary"
                          placeholder="Search Category"
                          onChange={(e) =>
                            handleSearchAttribute(e.target.value)
                          }
                        />
                        <div
                          className="input-group-append"
                          style={{
                            width: 30,
                            height: 36,
                            paddingTop: 2,
                            paddingBottom: 2,
                          }}
                        >
                          <button
                            className="p-1 btn btn-info-secondary"
                            type="button"
                            style={{ pointerEvents: "none" }}
                          >
                            <i
                              className="fa fa-search"
                              style={{ color: "#D8D8DC" }}
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="select-category-wrap">
                    <div className="flex-wrap d-flex">
                      {filteredAttList && filteredAttList.length > 0 ? (
                        <>
                          {filteredAttList
                            .slice(
                              0,
                              viewMoreCategories || searchString !== ""
                                ? filteredAttList.length
                                : Math.min(10, filteredAttList.length)
                            )
                            .map((item, index) => (
                              <div
                                className="select-category-item"
                                key={index + item.id}
                              >
                                <input
                                  type="checkbox"
                                  className="text-white btn-check"
                                  name="options-outlined"
                                  id={`success-outlined${item.id}`}
                                  autoComplete="off"
                                  defaultChecked={
                                    checkedAttributes &&
                                    checkedAttributes.length > 0 &&
                                    getChecked(item.id)
                                  }
                                  onClick={(e) => {
                                    setshowClearAllFlag(true);
                                    let index = checkedAttributes.findIndex(
                                      (att) => att.id === item.id
                                    );

                                    // Remove category from filterdeCategories
                                    let filteredCategories =
                                      filteredAttList.filter((catObject) => {
                                        return item.id !== catObject.id;
                                      });

                                    setFilteredAttList([...filteredCategories]);

                                    if (index === -1) {
                                      // let { id, name } = item;
                                      setCheckedAttributes([
                                        ...checkedAttributes,
                                        item,
                                      ]);
                                    } else {
                                      let checkedArr = [...checkedAttributes];
                                      checkedArr.splice(index, 1);
                                      setCheckedAttributes(checkedArr);
                                    }
                                  }}
                                />
                                <label
                                  className={`btn btn-outline-${
                                    item?.removed_from_selected
                                      ? "danger"
                                      : "primary"
                                  } btn-sm`}
                                  htmlFor={`success-outlined${item.id}`}
                                >
                                  {item.name}
                                </label>
                              </div>
                            ))}
                          <ViewMoreButton
                            state={viewMoreCategories}
                            handleClick={() =>
                              setViewMoreCategories(!viewMoreCategories)
                            }
                            condition={
                              searchString === "" &&
                              filteredAttList?.length > _max_items_show
                            }
                          />
                        </>
                      ) : (
                        <>
                          {searchString !== "" ? (
                            <div
                              className="p-2 alert alert-danger w-100 small"
                              role="alert"
                            >
                              <strong>Sorry!</strong> No Category found matching
                              your search query
                            </div>
                          ) : (
                            <>
                              <div className="no-cat-found">
                                No Categories found
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Category;
